// // this is for global preprod env
// const API_URL = 'https://preprodapi.pay10.com';

// export const environment = {
//   production: false,

//   USER_KEY: 'logged-user',
//   expiryTokenTime : 30 * 60 * 1000,

//   AUTHORIZER_URL: `${API_URL}/auth`,
//   USER_MANAGEMENT_URL: `${API_URL}/user-management`,
//   DEVELOPER_PORTAL_URL: `${API_URL}/developer-portal/proxy/developer-portal`,
//   AUDIT_URL: `${API_URL}/crash-report`,
//   PRIVACY_POLICY: 'https://pay10.ae/privacy-policy/',
//   TERMS_OF_SERVICE: 'https://pay10.ae/terms-of-service/',
//   API_EXP_SANDBOX_URL: `${API_URL}`,
//   API_EXP_API_URL: `${API_URL}`,
// DEV_PORTAL_URL: `${API_URL}`,
//   // pagination
//   defaultPageSize: 10,
//   defaultPageSizeArr: [10, 20, 30, 40, 50],

//   maxWaitingTimeForDownload: 30000, // 30 seconds
// };

// this is for UAE uat env
const API_URL = 'https://secure.pay10.ae';
export const environment = {
  production: false,

  USER_KEY: 'logged-user',
  expiryTokenTime : 30 * 60 * 1000,

  AUTHORIZER_URL: `${API_URL}/auth`,
  USER_MANAGEMENT_URL: `${API_URL}/user-management`,
  DEVELOPER_PORTAL_URL: `${API_URL}/developer-portal/proxy/developer-portal`,
  AUDIT_URL: `${API_URL}/crash-report`,
  PRIVACY_POLICY: 'https://pay10.ae/privacy-policy/',
  TERMS_OF_SERVICE: 'https://pay10.ae/terms-of-service/',

  API_EXP_SANDBOX_URL: `https://stagingpg.pay10.ae`,
  API_EXP_API_URL: `https://pg.pay10.ae`,
  WALLET_API_EXP_SANDBOX_URL: `https://preprodapi.pay10.asia`,
  WALLET_API_EXP_API_URL: `${API_URL}`,
  DEV_PORTAL_URL: `${API_URL}`,

  // pagination
  defaultPageSize: 10,
  defaultPageSizeArr: [10, 20, 30, 40, 50],

  maxWaitingTimeForDownload: 30000, // 30 seconds
};